RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsReactionsView = widgets.PostDetailsColumnView.extend({
        columnWidth: 6,
        className: function () {
            return [widgets.PostDetailsColumnView.prototype.className, 'reactions'].join(' ');
        }
    });


    const FbPostDetailsReactionsWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_reactions_title,
        description: RivalIQ.strings.facebook_insights_post_detail_reactions_description,
        view: FbPostDetailsReactionsView,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            const widgets = [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACTIONS'),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        displayString: RivalIQ.strings.facebook_insights_post_detail_reactions_total_reactions_display,
                        valueFormat: RivalIQ.formatter.formats.percentAbsolute,
                        property: 'total_reactions / facebook_insights_data.post_stories'
                    })

                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    hideMetric: true,
                    disableColors: true,
                    itemColumnSize: 4,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACTIONS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_reactions_reactions_title,
                        description: RivalIQ.strings.facebook_insights_post_detail_reactions_reactions_info,
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_LIKE',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_LOVE',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_HAHA',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_WOW',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_SORRY',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_ANGRY'
                        ]
                    })
                }
            ];

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_REACTIONS, FbPostDetailsReactionsWidget);

    const FbReelDetailsReactionsWidget = FbPostDetailsReactionsWidget.extend({
        description: RivalIQ.strings.facebook_insights_reel_detail_reactions_description,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            const widgets = [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACTIONS'),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        displayString: RivalIQ.strings.facebook_insights_post_detail_reactions_total_reactions_display,
                        valueFormat: RivalIQ.formatter.formats.percentAbsolute,
                        property: 'total_reactions / engagement_total'
                    })

                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    hideMetric: true,
                    disableColors: true,
                    itemColumnSize: 4,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACTIONS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_reactions_reactions_title,
                        description: RivalIQ.strings.facebook_insights_post_detail_reactions_reactions_info,
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_LIKE',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_LOVE',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_HAHA',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_WOW',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_SORRY',
                            'FACEBOOK_INSIGHTS_POST_REACTIONS_ANGRY'
                        ]
                    })
                }
            ];

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_REEL_REACTIONS, FbReelDetailsReactionsWidget);

});
